<template>
  <v-row
    @dragover.prevent="startDragging"
    style="height: 100%; position: relative;"
  >
    <div 
      class="drag-mask"
      @drop.prevent="addFile"
      @dragleave="dragging = false"
      v-show="dragging"
    >
      <v-row style="height: 100%;" class="align-center justify-center">
        <v-col class="text-center white--text display-2">
          <v-icon class="display-4 white--text">mdi-upload</v-icon> Upload
        </v-col>
      </v-row>
    </div>

    <v-col>
      <v-card class="elevation-0">
        <v-card-text>
          <media-browser ref="browser" />
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import MediaBrowser from './components/MediaBrowser'

export default {
  name: 'MediaIndex',
  components: {
    'media-browser': MediaBrowser
  },
  data: () => ({
    dragging: false
  }),
  mounted: function() {
    
  },
  watch: {
    
  },
  methods: {

    addFile(e) {
      this.dragging = false;
      this.$refs.browser.addFile(e);

    },
    startDragging() {
      this.dragging = true;
    }
  }
};
</script>

<style lang="scss" scoped>
  .drag-mask {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(66, 135, 245,.7);
    z-index: 50;
  }
</style>